/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Text as TextType } from 'hocs/localization'
import { LINK_STATUSES } from './contants'
import * as styles from './ConfirmChangeEmail.scss'

interface IProps {
  t: TextType,
  onResendConfirmEmail: () => void,
  status: LINK_STATUSES,
}

const ConfirmChangeEmail: React.FC<IProps> = ({
  t,
  status,
}) => {
  if (status === LINK_STATUSES.expired) {
    return (
      <React.Fragment>
        <div className={styles.header}>
          <h2>{t('header')}</h2>
        </div>
        <div className={styles.message}>
          {t('expired')}
        </div>
      </React.Fragment>
    )
  }
  if (status === LINK_STATUSES.notActual) {
    return (
      <React.Fragment>
        <div className={styles.header}>
          <h2>{t('header')}</h2>
        </div>
        <div className={styles.message}>
          {t('notActual')}
        </div>
      </React.Fragment>
    )
  }
  if (status === LINK_STATUSES.used) {
    return (
      <React.Fragment>
        <div className={styles.header}>
          <h2>{t('header')}</h2>
        </div>
        <div className={styles.message}>
          {t('used')}
        </div>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <div className={styles.header}>
        <h2>{t('header')}</h2>
      </div>
      <div className={styles.message}>
        {t('error')}
      </div>
    </React.Fragment>
  )
}

export default ConfirmChangeEmail
